<template>
  <div class="myNewsCenter">
    <!-- 消息中心 -->
    <van-nav-bar :left-text="$t('meetingReservation.text1')" left-arrow @click-left="onClickLeft" :fixed="true">
      
    </van-nav-bar>
    <div class="filterBox">
      <div class="showPopup" @click="handshowDtPicker">
        {{ bd }}
        <svg-icon icon-class="dropdown" style="width: 0.65em;height: 0.65em;margin-left: 5px;"></svg-icon>
      </div>
      <div class="showSelect" @click="handShowSelectPicker">
        {{ selectVal }}
        <svg-icon icon-class="dropdown" style="width: 0.65em;height: 0.65em;margin-left: 5px;"></svg-icon>
      </div>
    </div>
    <div class="content">
      <div class="content-box" :style="key == meetingRoomListData.length - 1 ? 'border-bottom:0' : ''"
        v-for="(value, key) in meetingRoomListData" :key="key" @click="visitDetails(value, key)">
        <div class="box-title">
          <div class="box-title-left">
            <strong>{{ value.name }}</strong>
            <span v-if="value.num_of_emp > 0">{{ value.num_of_emp }}{{ $t('meetingReservation.text31') }}</span>
          </div>
          <div class="box-title-right">
            {{ value.equipment }}
          </div>
        </div>
        <div class="box-list" style="border: 2px solid #ccc;">
          <div v-for="(item, index) in value.opt" v-show="item.show" :key="index" :class="[
            item.type == 1 ? 'huiyi-td-shixian' : 'huiyi-td-xuxian',
            item.active2 ? 'isSelect' : '',
            item.active1 ? 'isActive' : '',
            item.expire ? 'isExpire' : '',
            'gezi'
          ]">
          </div>
        </div>
        <div class="huiyi-table">
          <div class="huiyi-td td1">8</div>
          <div class="huiyi-td" style="font-size: 12px;">10</div>
          <div class="huiyi-td" style="font-size: 12px;">12</div>
          <div class="huiyi-td" style="font-size: 12px;">14</div>
          <div class="huiyi-td" style="font-size: 12px;">16</div>
          <div class="huiyi-td" style="font-size: 12px;">18</div>
          <div class="huiyi-td" style="font-size: 12px;">20</div>
          <div class="huiyi-td" style="font-size: 12px;">22</div>
        </div>
      </div>
    </div>
    <van-popup v-model="showSelectPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="selectPickerColumns"
        @confirm="onConfirmSelectPicker"
        @cancel="showSelectPicker = false"
      />
    </van-popup>
    <!-- 选择日期 -->
    <van-calendar v-model="showDtPicker" @confirm="onDtConfirm" />
    <van-popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
      <div class="detailsContainer">
        <div class="detailsContainerTit">
          <div style="
              width: 100%; 
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            ">
            <div class="detailsContainerTitH3"><strong>{{ openOpt.name }}</strong></div>
            <div class="detailsContainerTitP"><span>{{ $t('meetingReservation.text2') }}</span></div>
          </div>
        </div>
        <div class="detailsContainerBox"
          :style="showSelectTimeBox ? 'height:calc(100% - 3rem)' : 'height:calc(100% - 1.66667rem)'">
          <div class="detailsBoxList" v-for="(value, key) in openData" :key="key">
            <div class="detailsBoxSpan" :style="{
              opacity: ((value.show || value.active) ? '1' : '0'),
              color: (value.active ? 'blue' : '#ccc')
            }">{{ value.time }}</div>
            <div class="detailsBoxLine" :data-time="value.time" @click="userClickTime($event, value, key)" :style="{
              borderTop: (value.select?'none':(value.show ? '1px solid #ddd' : '1px dashed #ddd')),
              background: (value.select?'#aed4fb':(value.disable ? '#eee' : '#fff')),
            }">
              <span v-show="value.dim" style="color: blue;font-size: 12px;position: absolute;top: 5px;left: 5px;">{{ value.ydr }} <span style="color: #333;">{{ $t('meetingReservation.text30') }}</span></span>  
            </div>
          </div>
          <!-- 首次创建会议 -->
          <div class="userSelectTimeBox" v-show="showSelectTimeBox" :style="{
            top: slectObj.y,
            height: slectObj.h * 0.8 + 'rem'
          }">
            <div class="detailsBoxSpan" style="opacity:0;"></div>
            <div class="userSelectTimeBoxLine" @touchstart.stop="handleTouchStart" @touchmove.stop="handleTouchMove"
              @touchend.stop="handleTouchEnd">
              <div class="yuanA" @touchstart.stop="handleTouchStartA" @touchmove.stop="handleTouchMoveA"
                @touchend.stop="handleTouchEndA"></div>
              <div class="yuanA1" @touchstart.stop="handleTouchStartA" @touchmove.stop="handleTouchMoveA"
                @touchend.stop="handleTouchEndA"></div>
              <div class="yuanB" @touchstart.stop="handleTouchStartB" @touchmove.stop="handleTouchMoveB"
                @touchend.stop="handleTouchEndB"></div>
              <div class="yuanB1" @touchstart.stop="handleTouchStartB" @touchmove.stop="handleTouchMoveB"
                @touchend.stop="handleTouchEndB"></div>
            </div>
          </div>
        </div>
        <div class="detailsContainerFooter" v-if="showSelectTimeBox">
          <div class="footer-left">
            {{ timeObj }}
          </div>
          <van-button type="info" style="border-radius: 5px;" size="small" @click="ydHyClick($event,false,false,false)" :loading="showYdContent"
            :loading-text="$t('meetingReservation.text3')">{{ $t('meetingReservation.text4') }}</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 预定内容 -->
    <van-dialog 
      v-model="showYdContent" 
      :confirmButtonText="$t('meetingReservation.text5')" 
      :cancelButtonText="$t('meetingReservation.text6')" 
      :showCancelButton="true"
      className="ydContentVdialog" 
      :before-close="confirmTj"
    >
      <div class="ydnrContainer">
        <div class="ydnrBox">
          <div class="ydnrList" :class="meet_subjectR ? 'required' : ''">
            <van-field :disabled="meet_subjectZ" v-model="meet_subject" :label="meet_subjectW" :placeholder="$t('meetingReservation.text8')" />
          </div>
          <div class="ydnrList required" :class="yymmddbgR ? 'required' : ''">
            <van-field readonly clickable :disabled="yymmddbgZ" name="calendar" :value="yymmddbg" :label="yymmddbgW"
              :placeholder="$t('meetingReservation.text10')" @click="() => {yymmddbgZ?showYymmddbg = false:showYymmddbg = true}" />
          </div>
          <div class="ydnrList required" :class="tmbgR ? 'required' : ''">
            <van-field readonly clickable :disabled="tmbgZ" name="datetimePicker" :value="tmbg" :label="tmbgW"
              :placeholder="$t('meetingReservation.text12')" @click="() => {tmbgZ?showTmbgPicker = false:showTmbgPicker = true}" />
          </div>
          <div class="ydnrList required" :class="tmedR ? 'required' : ''">
            <van-field readonly clickable :disabled="tmedZ" name="datetimePicker" :value="tmed" :label="tmedW"
              :placeholder="$t('meetingReservation.text14')" @click="() => {tmedZ?showTmedPicker = false:showTmedPicker = true}" />
          </div>
          <div class="ydnrList" :class="roomnmR ? 'required' : ''">
            <van-field :disabled="roomnmZ" v-model="roomnm" :label="roomnmW" :placeholder="$t('meetingReservation.text16')" />
          </div>
          <div class="ydnrList" :class="empcodeR ? 'required' : ''">
            <van-field :disabled="empcodeZ" v-model="empcode" :label="empcodeW" :placeholder="$t('meetingReservation.text18')" />
          </div>
          <div class="ydnrList" :class="empnameR ? 'required' : ''">
            <van-field :disabled="empnameZ" v-model="empname" :label="empnameW" :placeholder="$t('meetingReservation.text20')" />
          </div>
          <div class="ydnrList" :class="isusedR ? 'required' : ''">
            <van-field :disabled="isusedZ" :label="isusedW">
              <template #input>
                <van-switch :disabled="isusedZ" v-model="isused" size="20" />
              </template>
            </van-field>
          </div>
          <div class="ydnrList" :class="meetcontR ? 'required' : ''">
            <van-field v-model="meetcont" :disabled="meetcontZ" rows="2" :label="meetcontW"  type="textarea"
              :placeholder="$t('meetingReservation.text23')" />
          </div>
          <div class="ydnrList" :class="remarkR ? 'required' : ''" style="border: 0 !important;">
            <van-field :disabled="remarkZ" v-model="remark" rows="2" :label="remarkW" type="textarea" :placeholder="$t('meetingReservation.text25')" />
          </div>
        </div>

      </div>
    </van-dialog>
    <van-calendar v-model="showYymmddbg" @confirm="onConfirmYymmddbg" :default-date="bdobj" />
    <van-popup v-model="showTmbgPicker" position="bottom">
      <van-datetime-picker type="time" v-model="tmbg" @confirm="onConfirmTmbg" @cancel="showTmbgPicker = false" />
    </van-popup>
    <van-popup v-model="showTmedPicker" position="bottom">
      <van-datetime-picker type="time" v-model="tmed" @confirm="onConfirmTmed" @cancel="showTmedPicker = false" />
    </van-popup>
  </div>

</template>

<script>
  import { Toast,Dialog } from 'vant';
  import { parseTime } from '@/utils'
  import { 
    getMeetingRoomList,
    getMeetingBookDetail,
    getMeetingBookFieldStatus,
    getBeforeActionList,
    processBeforeAction,
    postModuleRecord,
    processAfterAction,
    getMeetingRoomAreaList
  } from '@api/m1218.js'
  export default {
    data() {
      return {
        showDtPicker:false,                       // 选择预定日期 
        showSelectPicker:false,
        selectPickerColumns:[],
        bd: parseTime(new Date(), '{y}-{m}-{d}'), // 选择预定日期 
        bdobj:new Date(),                         // 选择预定日期 
        userInfo: JSON.parse(localStorage.userInfo) || {},
        meetingRoomListData:[],                   // 会议显示列表
        huiyiTheme:[],
        show:false,                               // 会议可视化配置弹出框
        openOpt:{},                               // 选定的会议 
        detaiData:[],                             // 会议详情，用于修改内容的创建
        openData:[                                // 会议可视化配置的时间对象 
          { id:"1",time:"0:00",show:true,disable:false,num:0,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"2",time:"0:30",show:false,disable:false,num:0.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"3",time:"1:00",show:true,disable:false,num:1,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"4",time:"1:30",show:false,disable:false,num:1.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"5",time:"2:00",show:true,disable:false,num:2,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"6",time:"2:30",show:false,disable:false,num:2.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"7",time:"3:00",show:true,disable:false,num:3,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"8",time:"3:30",show:false,disable:false,num:3.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"9",time:"4:00",show:true,disable:false,num:4,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"10",time:"4:30",show:false,disable:false,num:4.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"11",time:"5:00",show:true,disable:false,num:5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"12",time:"5:30",show:false,disable:false,num:5.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"13",time:"6:00",show:true,disable:false,num:6,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"14",time:"6:30",show:false,disable:false,num:6.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"15",time:"7:00",show:true,disable:false,num:7,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"16",time:"7:30",show:false,disable:false,num:7.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"17",time:"8:00",show:true,disable:false,num:8,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"18",time:"8:30",show:false,disable:false,num:8.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"19",time:"9:00",show:true,disable:false,num:9,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"20",time:"9:30",show:false,disable:false,num:9.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"21",time:"10:00",show:true,disable:false,num:10,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"22",time:"10:30",show:false,disable:false,num:10.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"23",time:"11:00",show:true,disable:false,num:11,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"24",time:"11:30",show:false,disable:false,num:11.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"25",time:"12:00",show:true,disable:false,num:12,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"26",time:"12:30",show:false,disable:false,num:12.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"27",time:"13:00",show:true,disable:false,num:13,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"28",time:"13:30",show:false,disable:false,num:13.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"29",time:"14:00",show:true,disable:false,num:14,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"30",time:"14:30",show:false,disable:false,num:14.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"31",time:"15:00",show:true,disable:false,num:15,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"32",time:"15:30",show:false,disable:false,num:15.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"33",time:"16:00",show:true,disable:false,num:16,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"34",time:"16:30",show:false,disable:false,num:16.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"35",time:"17:00",show:true,disable:false,num:17,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"36",time:"17:30",show:false,disable:false,num:17.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"37",time:"18:00",show:true,disable:false,num:18,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"38",time:"18:30",show:false,disable:false,num:18.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"39",time:"19:00",show:true,disable:false,num:19,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"40",time:"19:30",show:false,disable:false,num:19.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"41",time:"20:00",show:true,disable:false,num:20,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"42",time:"20:30",show:false,disable:false,num:20.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"43",time:"21:00",show:true,disable:false,num:21,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"44",time:"21:30",show:false,disable:false,num:21.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"45",time:"22:00",show:true,disable:false,num:22,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"46",time:"22:30",show:false,disable:false,num:22.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"47",time:"23:00",show:true,disable:false,num:23,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"48",time:"23:30",show:false,disable:false,num:23.5,active:false,select:false, ydr:"",dim:false, newautoid:0},
          { id:"49",time:"24:00",show:true,disable:false,num:24,active:false,select:false, ydr:"",dim:false, newautoid:0},
        ],
        clickSelectTime:0,  // 用户选择创建会议对象的时间段                              
        slectObj:{          // 可视化日期对象
          x:0,
          y:0,
          time:"",
          k:0,
          v:null,
          h:2
        },
        showSelectTimeBox:false, // 显示可视化日期
        startYA: 0, // 触摸开始的Y坐标
        endYA: 0, // 触摸结束的Y坐标
        touchingA: false, // 是否正在触摸
        startYB: 0, // 触摸开始的Y坐标
        endYB: 0, // 触摸结束的Y坐标
        touchingB: false, // 是否正在触摸
        startY: 0, // 触摸开始的Y坐标
        endY: 0, // 触摸结束的Y坐标
        touching: false, // 是否正在触摸
        showYdContent:false, // 预定内容弹出框
        showYymmddbg:false,  // 预定内容选择日期
        showTmbgPicker:false, // 预定内容选择时间
        showTmedPicker:false, // 预定内容选择时间

        meet_subject:"",      // 表单  
        yymmddbg:"",
        tmbg:"",
        tmed:"",
        roomnm:"",
        empcode:"",
        empname:"",
        isused:false,
        meetcont:"",
        remark:"",

        meet_subjectR:false,  // 是否必填
        yymmddbgR:false,
        tmbgR:false,
        tmedR:false,
        roomnmR:false,
        empcodeR:false,
        empnameR:false,
        isusedR:false,
        meetcontR:false,
        remarkR:false,
        empid:0,

        meet_subjectZ:false,  // 是否只读
        yymmddbgZ:false,
        tmbgZ:false,
        tmedZ:false,
        roomnmZ:false,
        empcodeZ:false,
        empnameZ:false,
        isusedZ:false,
        meetcontZ:false,
        remarkZ:false,
        
        meet_subjectW:"",      // 表单中文 
        yymmddbgW:"",
        tmbgW:"",
        tmedW:"",
        roomnmW:"",
        empcodeW:"",
        empnameW:"",
        isusedW:false,
        meetcontW:"",
        remarkW:"",

        openResObj:{},     // 预定内容默认值  
        showObj:{},        // 修改情况下的预定内容

        showtype:1, //1是创建 2是修改
        showautoid:0, // 0是创建，其它是修改

        selectVal:""
      }
    },
    created() {
      this.initData();
    },
    computed:{
      timeObj() {
        let str = this.openData[this.slectObj.k].time + " - " +  this.openData[this.slectObj.k + this.slectObj.h].time
        return this.bd+' ' + str
      },
    },
    
    methods: {
      async initData () {
        await this.getMeetingRoomDd();
        await this.getDataDetail()
      },
      async getMeetingRoomDd() {
        this.selectPickerColumns = []
        await getMeetingRoomAreaList({
          username:this.userInfo.username,
          langid: localStorage.getItem('langid')
        }).then(res=>{
          if(res && res.data.length > 0){
            const arr = res.data
            arr.forEach(element => {
              this.selectPickerColumns.push(element.area)
            })
            this.selectVal = this.selectPickerColumns[0]
          }
        })
      },
      onConfirmSelectPicker(v) {
        this.selectVal = v;
        this.showSelectPicker = false;
        this.getDataDetail(this.bd)
      },
      // 预定内容创建或者修改
      ydHyClick (ee,p1,p2,p3) {
        this.yymmddbg = p1 || this.bd;
        this.tmbg = p2 || this.openData[this.slectObj.k].time
        this.tmed = p3 || this.openData[this.slectObj.k + this.slectObj.h].time
        getMeetingBookFieldStatus({
          mr_id:this.openOpt.autoid,
          yymmddbg:p1 || this.yymmddbg,
          tmbg:p2 || this.tmbg,
          tmed:p3 || this.tmed,
          username:this.userInfo.username,
          langid: localStorage.getItem('langid'),
          area:this.selectVal
        }).then(res=>{
          this.openResObj = res.data;
          for(let i = 0; i < this.openResObj.length; i++){
            if(this.openResObj[i].fieldname == 'meet_subject'){
              this.meet_subject = this.showObj && this.showObj.meet_subject?this.showObj.meet_subject:this.openResObj[i].fieldvalue
              this.meet_subjectR = this.openResObj[i].mustinput
              this.meet_subjectZ = this.openResObj[i].isreadonly
              this.meet_subjectW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'yymmddbg'){
              this.yymmddbgR = this.openResObj[i].mustinput
              this.yymmddbgZ = this.openResObj[i].isreadonly
              this.yymmddbgW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'tmbg'){
              this.tmbgR = this.openResObj[i].mustinput
              this.tmbgZ = this.openResObj[i].isreadonly
              this.tmbgW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'tmed'){
              this.tmedR = this.openResObj[i].mustinput
              this.tmedZ = this.openResObj[i].isreadonly
              this.tmedW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'roomnm'){
              this.roomnm = this.showObj && this.showObj.roomnm?this.showObj.roomnm:this.openResObj[i].fieldvalue
              this.roomnmR = this.openResObj[i].mustinput
              this.roomnmZ = this.openResObj[i].isreadonly
              this.roomnmW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'empcode'){
              this.empcode = this.showObj && this.showObj.empcode?this.showObj.empcode:this.openResObj[i].fieldvalue
              this.empcodeR = this.openResObj[i].mustinput
              this.empcodeZ = this.openResObj[i].isreadonly
              this.empcodeW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'empname'){
              this.empname = this.showObj && this.showObj.empname?this.showObj.empname:this.openResObj[i].fieldvalue
              this.empnameR = this.openResObj[i].mustinput
              this.empnameZ = this.openResObj[i].isreadonly
              this.empnameW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'isused'){
              this.isused = this.showObj && (this.showObj.isused == 'false' || this.showObj.isused == false)?(this.openResObj[i].fieldvalue == 'true'?true:false):true
              this.isusedR = this.openResObj[i].mustinput
              this.isusedZ = this.openResObj[i].isreadonly
              this.isusedW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'meetcont'){
              this.meetcont = this.showObj && this.showObj.meetcont?this.showObj.meetcont:this.openResObj[i].fieldvalue
              this.meetcontR = this.openResObj[i].mustinput
              this.meetcontZ = this.openResObj[i].isreadonly
              this.meetcontW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'remark'){
              this.remark = this.showObj && this.showObj.remark?this.showObj.remark:this.openResObj[i].fieldvalue
              this.remarkR = this.openResObj[i].mustinput
              this.remarkZ = this.openResObj[i].isreadonly
              this.remarkW = this.openResObj[i].chnname
            }else if(this.openResObj[i].fieldname == 'empid'){
              this.empid = this.showObj && this.showObj.fieldname?this.showObj.fieldname:this.openResObj[i].fieldvalue
            }
          }
          this.showYdContent = true;
        })  
        
      },
      
      // 预定内容提交或修改
      async confirmTj (action, done) {
        if(action == 'cancel'){
          done();
        }else{
          const moduleno = '1218'
          const res1 = await getBeforeActionList({
            actype: 0,
            moduleno,
            username: this.userInfo.username
          })
          const arr = res1.data // acprocname数组
          const editstate = this.showtype;
          const autoid = this.showautoid;
          
          let logdetail = "";
          let fromObj = {
            meet_subject:this.meet_subject,
            yymmddbg:this.yymmddbg,
            tmbg:this.tmbg,
            tmed:this.tmed,
            roomnm:this.roomnm,
            empcode:this.empcode,
            isused:String(this.isused),
            meetcont:this.meetcont,
            remark:this.remark,
            empid:String(this.empid),
            autoid:this.showautoid+''
          };
          let fromStr = JSON.stringify(fromObj)
          
          for (const item of arr){
            const result = await processBeforeAction({
              acproname: item.acprocname,
              editstate: editstate,
              moduleno,
              username: this.userInfo.username,
              autoid,
              formstr: fromStr
            })
            if (result.data.length > 0 && result.data[0].info){
              Toast(result.data[0].info)
              return false;
            }else if(result.iserror == '1'){
              Toast(this.$t('meetingReservation.text26'));
              return false;
            }
          }
          const res2 = await postModuleRecord({
            moduleno,
            editstate: editstate,
            pcuserinfo: this.userInfo.username, // 用户名称,
            formstr: fromStr,
            logdetail: logdetail
          })
          const data2 = res2.data[0]
          if (res2.iserror === '0' && data2.info){
            Toast(data2.info)
            return false;
          }else if (res2.iserror === '1'){
            Toast(this.$t('meetingReservation.text26'))
            return false;
          }
          processAfterAction({
            actype: 0,
            editstate: editstate,
            moduleno,
            username: this.userInfo.username, // 用户名称,
            autoid: this.showautoid || data2.insid,
            formstr: fromStr
          }).then(res3=>{
            if(res3.iserror == "0"){
              Toast(this.$t('meetingReservation.text27'))
              done();
              this.show = false;
              this.getDataDetail(this.bd)
            }else{
              Toast(this.$t('meetingReservation.text26'))
              return false;
            }
          })
        }
      },
      handShowSelectPicker() {
        this.showSelectPicker = true;
      },
      
      // 显示下拉框
      handshowDtPicker () {
        this.showDtPicker = true
      },
      
      // 下拉框选择日期
      onDtConfirm (v) {
        this.bdobj = v; // 用于日期联动
        this.bd = parseTime(v, '{y}-{m}-{d}')
        this.getDataDetail(this.bd)
        this.showDtPicker = false
      },
      onConfirmYymmddbg (v) {
        this.yymmddbg = parseTime(v, '{y}-{m}-{d}')
        this.showYymmddbg = false;
      },
      onConfirmTmbg (v) {
        this.showTmbgPicker = false;
      },
      onConfirmTmed (v) {
        this.showTmedPicker = false;
      },
      onClickLeft() {
        if(this.$route.query.from == 'home'){
            this.$router.push('/home')
        }else{
            this.$router.push('/personCen')
        }
      },
      fillZero(str){
        var realNum;
        if (str < 10) {
            realNum = '0' + str;
        } else {
            realNum = str;
        }
        return realNum;
      },
      // 创建预定列表
      async getList (ddd) {
        await getMeetingRoomList({
          username:this.userInfo.username,
          langid: localStorage.getItem('langid'),
          area:this.selectVal
        }).then(res=>{
          this.meetingRoomListData = res.data;
          const tody = new Date().getFullYear() + '' + this.fillZero(new Date().getMonth()+1) + '' + this.fillZero(new Date().getDate())
          const stime = ddd?String(ddd).replace(/-/g,""):0
          // 检验时间是否为今天，false代表是今天
          let jy = parseInt(tody) < parseInt(stime);
          const nowTimeHours = new Date().getHours();
          const nowTimeMinutes = new Date().getMinutes();
          const allTime = nowTimeHours + (nowTimeMinutes/60)
          for(let i = 0; i < this.meetingRoomListData.length; i++){
            this.meetingRoomListData[i].ydr = ""
            this.meetingRoomListData[i].opt = [
              { start:0,end:0.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:0.5,end:1,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:1,end:1.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:1.5,end:2,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:2,end:2.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:2.5,end:3,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:3,end:3.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:3.5,end:4,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:4,end:4.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:4.5,end:5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:5,end:5.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:5.5,end:6,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:6,end:6.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:6.5,end:7,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:7.5,end:8,active1:false,active2:false,type:1,expire:!jy && allTime > 8, data:null,show:true},
              { start:8,end:8.5,active1:false,active2:false,type:2,expire:!jy && allTime > 8.5, data:null,show:true },
              { start:8.5,end:9,active1:false,active2:false,type:1,expire:!jy && allTime > 9, data:null,show:true },
              { start:9,end:9.5,active1:false,active2:false,type:2,expire:!jy && allTime > 9.5, data:null,show:true },
              { start:9.5,end:10,active1:false,active2:false,type:1,expire:!jy && allTime > 10, data:null,show:true },
              { start:10,end:10.5,active1:false,active2:false,type:2,expire:!jy && allTime > 10.5, data:null,show:true },
              { start:10.5,end:11,active1:false,active2:false,type:1,expire:!jy && allTime > 11, data:null,show:true },
              { start:11,end:11.5,active1:false,active2:false,type:2,expire:!jy && allTime > 11.5, data:null,show:true },
              { start:11.5,end:12,active1:false,active2:false,type:1,expire:!jy && allTime > 12, data:null,show:true },
              { start:12,end:12.5,active1:false,active2:false,type:2,expire:!jy && allTime > 12.5, data:null,show:true },
              { start:12.5,end:13,active1:false,active2:false,type:1,expire:!jy && allTime > 13, data:null,show:true },
              { start:13,end:13.5,active1:false,active2:false,type:2,expire:!jy && allTime > 13.5, data:null,show:true },
              { start:13.5,end:14,active1:false,active2:false,type:1,expire:!jy && allTime > 14, data:null,show:true },
              { start:14,end:14.5,active1:false,active2:false,type:2,expire:!jy && allTime > 14.5, data:null,show:true },
              { start:14.5,end:15,active1:false,active2:false,type:1,expire:!jy && allTime > 15, data:null,show:true },
              { start:15,end:15.5,active1:false,active2:false,type:2,expire:!jy && allTime > 15.5, data:null,show:true },
              { start:15.5,end:16,active1:false,active2:false,type:1,expire:!jy && allTime > 16, data:null,show:true },
              { start:16,end:16.5,active1:false,active2:false,type:2,expire:!jy && allTime > 16.5, data:null,show:true },
              { start:16.5,end:17,active1:false,active2:false,type:1,expire:!jy && allTime > 17, data:null,show:true },
              { start:17,end:17.5,active1:false,active2:false,type:2,expire:!jy && allTime > 17.5, data:null,show:true },
              { start:17.5,end:18,active1:false,active2:false,type:1,expire:!jy && allTime > 18, data:null,show:true },
              { start:18,end:18.5,active1:false,active2:false,type:2,expire:!jy && allTime > 18.5, data:null,show:true },
              { start:18.5,end:19,active1:false,active2:false,type:1,expire:!jy && allTime > 19, data:null,show:true },
              { start:19,end:19.5,active1:false,active2:false,type:2,expire:!jy && allTime > 19.5, data:null,show:true },
              { start:19.5,end:20,active1:false,active2:false,type:1,expire:!jy && allTime > 20, data:null,show:true },
              { start:20,end:20.5,active1:false,active2:false,type:2,expire:!jy && allTime > 20.5, data:null,show:true },
              { start:20.5,end:21,active1:false,active2:false,type:1,expire:!jy && allTime > 21, data:null,show:true },
              { start:21,end:21.5,active1:false,active2:false,type:2,expire:!jy && allTime > 21.5, data:null,show:true },
              { start:21.5,end:22,active1:false,active2:false,type:1,expire:!jy && allTime > 22, data:null,show:true },
              { start:22,end:22.5,active1:false,active2:false,type:2,expire:!jy && allTime > 22.5, data:null,show:true },
              { start:22.5,end:23,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:23,end:23.5,active1:false,active2:false,type:1,expire:false, data:null,show:false},
              { start:23.5,end:24,active1:false,active2:false,type:1,expire:false, data:null,show:false},
            ];
            this.meetingRoomListData[i].selectOpt = [];
            this.meetingRoomListData[i].btnStatus = true;
          }
        })
      },
      // 日期变化的时候 更新已选中
      async getDataDetail(ddd) {
        await this.getList(ddd);
        this.huiyiTheme = [];
        const d = new Date();
        const yy = d.getFullYear();
        const mm = d.getMonth();
        const dd = d.getDate();
        const yymmdd = yy + '-' + (mm+1 >= 10?''+(mm+1):'0'+(mm+1)) + '-' + (dd >= 10?''+dd:'0'+dd)
        await getMeetingBookDetail({
          yymmdd:ddd?ddd:yymmdd,
          username:this.userInfo.username,
          langid: localStorage.getItem('langid'),
          area:this.selectVal
        }).then(res=>{
          const data = res.data;
          this.detaiData = data;
          if(data && data.length > 0){
            for(let i = 0; i < data.length; i++){
              let beginT = 0;
              let endT = 0;
              if(data[i].tmbg){
                if(parseInt(data[i].tmbg.slice(3)) == 0){
                  beginT = parseInt(data[i].tmbg.slice(0,2))
                }else{
                  beginT = parseInt(data[i].tmbg.slice(0,2))+0.5
                }
              }
              if(data[i].tmed){
                if(parseInt(data[i].tmed.slice(3)) == 0){
                  endT = parseInt(data[i].tmed.slice(0,2))
                }else{
                  endT = parseInt(data[i].tmed.slice(0,2))+0.5
                }
              }
              // 如果某段时间存在会议，则列表数据的active2为true，标志为浅蓝色
              for(let j = 0; j < this.meetingRoomListData.length; j++){
                if(this.meetingRoomListData[j].name == data[i].roomnm){
                  this.meetingRoomListData[j].ydr = data[i].empname
                  let mkopt = this.meetingRoomListData[j].opt;
                  for(let k = 0; k < mkopt.length; k++){
                    for(let l = 0; l < (endT - beginT)*2; l++){
                      if(mkopt[k].start == beginT+l*0.5 && mkopt[k].end == beginT+l*0.5+0.5){
                        mkopt[k].active2 = true;
                        mkopt[k].data = data[i];
                      }
                    }
                  }
                }
              }
            }
            this.huiyiTheme =  data;
            this.$forceUpdate();
          }
        })
      },
      visitDetails (value,key) {
        this.show = true;
        this.openOpt = value;
        const nowTimeHours = new Date().getHours();
        const nowTimeMinutes = new Date().getMinutes();
        const allTime = nowTimeHours + (nowTimeMinutes/60)
        const vopt = value.opt;
        this.clickSelectTime = allTime;
        this.clearOpenDataActive();
        this.initOpen();
        this.clearOpenDataSelect();
        const tody = new Date().getFullYear() + '' + this.fillZero(new Date().getMonth()+1) + '' + this.fillZero(new Date().getDate())
        const stime = this.bd?String(this.bd).replace(/-/g,""):0
        let jy = parseInt(tody) < parseInt(stime);
        
        for(let i = 0; i < this.openData.length; i++){
          for(let j = 0; j < vopt.length; j++){
            // 把已安排会议的详情页即openData的数据设置为true，即显示为浅蓝色
            if(this.openData[i].num == vopt[j].start && vopt[j].active2){
              this.openData[i].select = true;
              this.openData[i].ydr = vopt[j].data.empname;
              this.openData[i].newautoid = vopt[j].data.autoid;
            }
          }
          // 如果不是今天，则全部设置为可修改
          if(jy){
            this.openData[i].disable = false;
          }else{
            if(this.openData[i].num < allTime - 0.5){
              this.openData[i].disable = true;
            }else{
              this.openData[i].disable = false;
            }
          }
        }
        for(let i = 0; i < this.openData.length; i++){
          if(i > 0){
            // 只显示一项已预定，有两种情况
            if(this.openData[i].select){
              // 一是两段会议不是黏着的时候，根据上下文是否存在select判断
              if(!this.openData[i-1].select){
                this.openData[i].dim = true;
              }else{
                // 二是两段会议黏着的时候，根据上下文的autoid是否一样去判断
                if(this.openData[i].newautoid && this.openData[i-1].newautoid && this.openData[i].newautoid != this.openData[i-1].newautoid){
                  this.openData[i].dim = true;
                }
              }
            }
          }
        }
      },
      // 初始化选定的日期对象
      initOpen() {
        this.slectObj.x = 0;
        this.slectObj.y = 0;
        this.slectObj.time = "";
        this.slectObj.k = 0;
        this.slectObj.v = null;
        this.slectObj.h = 2;
        this.showSelectTimeBox = false;
        this.startYA = 0;
        this.endYA = 0;
        this.touchingA = false;
        this.startYB = 0;
        this.endYB = 0;
        this.touchingB = false;
        this.startY = 0;
        this.endY = 0;
        this.touching = false;
        this.showtype = 1;
        this.showautoid = 0;
        this.showObj = {};
      },
      // 初始化可视化日期对象
      clearOpenDataActive () {
        for(let i = 0; i < this.openData.length; i++){
          this.openData[i].active = false;
        }
      },
      clearOpenDataSelect () {
        for(let i = 0; i < this.openData.length; i++){
          this.openData[i].select = false;
          this.openData[i].dim = false;
          this.openData[i].newautoid = 0;
        }
      },
      
      userClickTime (e,v,k) {
        const tody = new Date().getFullYear() + '' + this.fillZero(new Date().getMonth()+1) + '' + this.fillZero(new Date().getDate())
        const stime = this.bd?String(this.bd).replace(/-/g,""):0
        let jy = parseInt(tody) < parseInt(stime);
        // 如果是当天，且时间已过期，则提醒用户
        if(this.clickSelectTime - 0.5 > v.num && !jy){
          Toast(this.$t('meetingReservation.text28'));
        }else if(v.select){
          let arr = [];
          for(let  i = 0; i < this.detaiData.length; i++){
            if(this.detaiData[i].roomnm == this.openOpt.name){
              arr.push(this.detaiData[i])
            }
          }
          let vtime = 0;
          if(v.time){
            if(parseInt(v.time.slice(3)) == 0){
              vtime = parseInt(v.time.slice(0,2))
            }else{
              vtime = parseInt(v.time.slice(0,2))+0.5
            }
          }
          for(let i = 0; i < arr.length; i++){
            let beginT = 0;
            let endT = 0;
            if(arr[i].tmbg){
              if(parseInt(arr[i].tmbg.slice(3)) == 0){
                beginT = parseInt(arr[i].tmbg.slice(0,2))
              }else{
                beginT = parseInt(arr[i].tmbg.slice(0,2))+0.5
              }
            }
            if(arr[i].tmed){
              if(parseInt(arr[i].tmed.slice(3)) == 0){
                endT = parseInt(arr[i].tmed.slice(0,2))
              }else{
                endT = parseInt(arr[i].tmed.slice(0,2))+0.5
              }
            }
            // 访问详情页
            if(vtime >= beginT && vtime <= endT){
              this.showtype = 2
              this.showautoid = arr[i].autoid;
              this.showObj = arr[i]
              this.ydHyClick(null,arr[i].yymmddbg,arr[i].tmbg,arr[i].tmed)
              break;
            }
          }
        }else{
          // 判断是否存在足够的空间
          for(let i = 0; i < this.slectObj.h; i++){
            if(this.openData[i+k] && this.openData[i+k].select){
              Dialog({ message: this.$t('meetingReservation.text29') });
              return;
            }
          }
          this.clearOpenDataActive();
          this.showSelectTimeBox = true;
          this.slectObj.time = v.time;
          this.slectObj.v = v;
          // 如果用户在列表页尾部点击创建，则上移到适合的位置
          if((k+this.slectObj.h) >= 49){
            this.slectObj.y = (49 - this.slectObj.h)*0.8+'rem';
            this.openData[48].active = true;
            this.openData[48 - this.slectObj.h].active = true;
            this.slectObj.k = (48 - this.slectObj.h);
          }else{
            this.slectObj.k = k;
            v.active = true;
            this.slectObj.y = (k+1)*0.8+'rem';
            this.openData[k+this.slectObj.h].active = true;
          }
        }
      },
      handleTouchStartA(e) {
        if (e.touches.length === 1) {
          this.touchingA = true;
          this.startYA = e.touches[0].clientY;
        }
      },
      handleTouchMoveA(e) {
        if (this.touchingA) {
          // 阻止页面滚动
          e.preventDefault();
          this.endYA = e.touches[0].clientY;
          const deltaY = this.endYA - this.startYA;
          // 根据滑动方向做相应处理
          // (window.screen.width/750*60)*0.8的值越小，滑动越快
          if (Math.abs(deltaY) > (window.screen.width/750*60)*0.8) { 
            if (deltaY > 0) {
              // 向下滑动
              // console.log(this.openData[this.slectObj.k + 1],'this.openData[this.slectObj.k + 1]')
              if(this.slectObj.h == 1){
                console.log("无法下滑")
                return;
              }
              this.slectObj.h = (this.slectObj.h - 1);
              this.slectObj.k = (this.slectObj.k + 1);
              this.slectObj.y = (this.slectObj.k+1)*0.8+'rem';
              this.startYA = e.touches[0].clientY;
              this.openData[this.slectObj.k - 1].active = false;
              this.openData[this.slectObj.k].active = true;
            } else {
              // 向上滑动
              if(this.slectObj.k <= 0){
                console.log("无法上滑")
              }else{
                if(this.openData[this.slectObj.k - 1].disable || this.openData[this.slectObj.k - 1].select){
                  console.log("无法上滑")
                }else{
                  this.slectObj.k = (this.slectObj.k - 1);
                  this.slectObj.h = (this.slectObj.h + 1);
                  this.slectObj.y = (this.slectObj.k+1)*0.8+'rem';
                  this.startYA = e.touches[0].clientY;
                  this.openData[this.slectObj.k + 1].active = false;
                  this.openData[this.slectObj.k].active = true;
                  // console.log(,'this.slectObj.k')
                }
              }
            }
          }
        }
      },
      handleTouchEndA(e) {
        this.touchingA = false;
        this.startYA = 0;
        this.endYA = 0;
      },
      handleTouchStartB(e) {
        if (e.touches.length === 1) {
          this.touchingB = true;
          this.startYB = e.touches[0].clientY;
        }
      },
      handleTouchMoveB(e) {
        if (this.touchingB) {
          // 阻止页面滚动
          e.preventDefault();
          this.endYB = e.touches[0].clientY;
          const deltaY = this.endYB - this.startYB;
          // 根据滑动方向做相应处理
          if (Math.abs(deltaY) > (window.screen.width/750*60)*0.8) { 
            if (deltaY > 0) {
              // 向下滑动
              if((this.slectObj.k+this.slectObj.h) >= 48 || this.openData[(this.slectObj.k+this.slectObj.h)].select){
                console.log("无法下滑")
                return;
              }
              this.slectObj.h = (this.slectObj.h + 1);
              this.openData[this.slectObj.k + this.slectObj.h].active = true;
              this.openData[this.slectObj.k + this.slectObj.h - 1].active = false;
              this.startYB = e.touches[0].clientY;
            } else {
              // 向上滑动
              if(this.slectObj.h == 1){
                console.log("无法上滑")
                return;
              }
              this.slectObj.h = (this.slectObj.h - 1);
              this.startYB = e.touches[0].clientY;
              this.openData[this.slectObj.k + this.slectObj.h].active = true;
              this.openData[this.slectObj.k + this.slectObj.h + 1].active = false;
            }
          }
        }
      },
      handleTouchEndB(e) {
        this.touchingB = false;
        this.startYB = 0;
        this.endYB = 0;
      },
      handleTouchStart(e) {
        if (e.touches.length === 1) {
          this.touching = true;
          this.startY = e.touches[0].clientY;
        }
      },
      handleTouchMove(e) {
        if (this.touching) {
          // 阻止页面滚动
          e.preventDefault();
          this.endY = e.touches[0].clientY;
          const deltaY = this.endY - this.startY;
          // 根据滑动方向做相应处理
          if (Math.abs(deltaY) > (window.screen.width/750*60)*0.8) { // 10是一个阈值，用于判断是否是有效滑动
            if (deltaY > 0) {
              if((this.slectObj.k+this.slectObj.h) >= 48 || this.openData[(this.slectObj.k+this.slectObj.h)].select){
                console.log("无法下滑")
                return;
              }
              this.slectObj.k = this.slectObj.k + 1
              this.slectObj.y = (this.slectObj.k+1)*0.8+'rem';
              this.openData[this.slectObj.k + this.slectObj.h].active = true;
              this.openData[this.slectObj.k + this.slectObj.h - 1].active = false;
              this.openData[this.slectObj.k].active = true;
              this.openData[this.slectObj.k - 1].active = false;
              this.startY = e.touches[0].clientY;
            } else {
              if(this.slectObj.k <= 0){
                console.log("无法上滑")
                return;
              }
              if(this.openData[this.slectObj.k - 1].disable || this.openData[this.slectObj.k - 1].select){
                console.log("无法上滑")
                return;
              }
              this.slectObj.k = this.slectObj.k - 1
              this.slectObj.y = (this.slectObj.k+1)*0.8+'rem';
              if(this.slectObj.h >= 2){
                this.openData[this.slectObj.k + this.slectObj.h].active = true;
                this.openData[this.slectObj.k + this.slectObj.h + 1].active = false;
                this.openData[this.slectObj.k].active = true;
                this.openData[this.slectObj.k + 1].active = false;
              }else{
                this.openData[this.slectObj.k].active = true;
                this.openData[this.slectObj.k + 1].active = true;
                this.openData[this.slectObj.k + this.slectObj.h + 1].active = false;
              }
              this.startY = e.touches[0].clientY;
            }
          }
        }
      },
      handleTouchEnd(e) {
        this.touching = false;
        this.startY = 0;
        this.endY = 0;
      },
    }
  }
  </script>

<style lang="less" scoped>
.myNewsCenter {
  height: 100vh;
  overflow: hidden;

  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }

      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .filterBox{
    margin-top: 1.22667rem;
    height: 88px;
    background: #fff;
    box-shadow: 3px 3px #ccc;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .showPopup {
    padding: 10px 0 10px 28px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-size: 32px;
  }
  .showSelect{
    padding: 10px 28px 10px 0;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-size: 32px;
    
  }
  .content {
    
    overflow: auto;
    height: calc(100% - 177px);
    padding: 28px 28px 0;
    background: #fff;

    .content-box {
      width: 100%;
      padding-bottom: 30px;
      border-bottom: 1px solid #eee;
      margin-bottom: 30px;

      .box-title {
        display: flex;
        justify-content: space-between;
        align-items: end;
        margin-bottom: 36px;
        width: 100%;
        flex-wrap: nowrap;

        .box-title-left {
          display: flex;
          align-items: end;

          strong {
            font-size: 32px;
            font-weight: bold;
          }

          span {
            font-size: 20px;
            padding: 8px;
            border: 1px solid #ccc;
            display: block;
            border-radius: 8px;
            margin-left: 12px;
          }
        }

        .box-title-right {
          font-size: 20px;
          color: #666;
        }
      }

      .box-list {
        width: 100%;
        border: 2px solid #ccc;
        display: flex;
        flex-wrap: nowrap;
        border-radius: 4px;
      }

      .gezi {
        flex: 1;
        height: 50px;

        &.huiyi-td-shixian {
          border-right: 1px solid #ccc;
        }

        &.isExpire {
          background: #ddd;
        }

        &.isSelect {
          background: #bdd8f3 !important;
          // border-right: 1px solid #bdd8f3 !important;
        }
      }
    }

    .huiyi-table {
      width: 100%;
      display: flex;
      margin-top: 12px;
      position: relative;

      .huiyi-td {
        // flex: 1;
        font-size: 24px !important;
        width: 28px !important;
        text-align: center;
        position: relative;
        margin-left: 64px;
        color: #666;

        &.td1 {
          margin-left: 12px;
        }
      }
    }
  }
}

// 详情
.detailsContainer {
  width: 100%;
  height: 100%;

  .detailsContainerTit {
    height: 125px;
    width: 100%;

    display: flex;
    align-items: center;
    flex-wrap: wrap;
    box-shadow: 1px 2px 3px #ddd;

    .detailsContainerTitH3 {
      margin: 0;
      text-align: center;
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      strong {
        font-size: 32px;
      }
    }

    .detailsContainerTitP {
      margin: 0;
      text-align: center;
      width: 100%;
      margin-top: 7px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      top: -5px;

      span {
        color: #666;
        font-size: 24px;
      }
    }
  }

  .detailsContainerBox {
    height: calc(100% - 125px);
    width: 100%;
    overflow: auto;
    padding-top: 60px;
    background: #f8f8f8;
    position: relative;

    .detailsBoxList {
      width: 100%;
      display: flex;
      height: 0.8rem;

      .detailsBoxSpan {
        font-size: 24px;
        color: #ccc;
        width: 100px;
        min-width: 100px;
        text-align: right;
        line-height: 1;
        position: relative;
        top: -12px;
        padding-right: 10px;
      }

      .detailsBoxLine {
        width: 100%;
        flex: 1;
        background: #fff;
        height: 100%;
        border-top: 1px solid #ddd;
        position: relative;
      }
    }

    .userSelectTimeBox {
      position: absolute;
      right: 0;
      min-height: 0.8rem !important;
      height: 1.6rem;
      z-index: 999999;
      width: 100%;
      display: flex;

      .detailsBoxSpan {
        font-size: 24px;
        color: #ccc;
        width: 100px;
        min-width: 100px;
        text-align: right;
        line-height: 1;
        position: relative;
        top: -12px;
        padding-right: 10px;
      }

      .userSelectTimeBoxLine {
        width: 100%;
        flex: 1;
        background: #fff;
        height: 100%;
        border: 1px solid blue !important;
        background: rgba(115, 125, 245, 0.3) !important;
        // border-right: 0 !important;
        position: relative;
        border-radius: 10px;

        .yuanA,
        .yuanA1 {
          width: 20px;
          height: 20px;
          background: #fff;
          border: 1px solid blue;
          border-radius: 20px;
          position: absolute;
          top: -11px;
          left: 50px;
        }

        .yuanA1 {
          left: 0;
          opacity: 0;
          width: 120px;
          height: 100px;
          top: -50px;
        }

        .yuanB,
        .yuanB1 {
          width: 20px;
          height: 20px;
          background: #fff;
          border: 1px solid blue;
          border-radius: 20px;
          position: absolute;
          bottom: -11px;
          right: 50px;
        }

        .yuanB1 {
          right: 0;
          opacity: 0;
          width: 120px;
          height: 100px;
          bottom: -50px;
        }
      }
    }
  }

  .detailsContainerFooter {
    position: fixed;
    bottom: 0;
    z-index: 99;
    left: 0;
    height: 100px;
    background: rgb(238, 238, 238);
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    justify-content: space-between;

    .footer-left {
      font-size: 32px;
    }
  }
}

.ydnrContainer {
  width: 100%;
  height: 100%;
  background: #fff;

  .ydnrBox {
    padding: 32px 32px 0;
  }

  .ydnrList {
    border-bottom: 1px solid #ccc;

    &.required {
      /deep/.van-cell__title {
        span {
          color: red !important;
        }
      }
    }
  }

  /deep/.van-cell {
    padding: 16px 0 !important;
  }
}

.ydContentVdialog {
  width: 90% !important;

  top: 50% !important;
}
</style>